import { isDev } from "./environment-helpers";
import { logDebug } from "./logger";
import { reportFrontendError } from "./report-frontend-error";
import { statusOf } from "./shopper-error";
export var unhandledError = function unhandledError(context, error) {
  var _statusOf;
  if (isDev()) {
    logDebug(context, error);
    return;
  }

  // 500 was applied to every frontend error regardless of cause, so shopper-side
  // and upstream failures all fingerprinted as server faults of ours.
  // `context` went into errorDataBuilder's Lambda-context slot, which reads only
  // awsRequestId and clientContext - so all 13 labels were dropped in transit.
  reportFrontendError(error, (_statusOf = statusOf(error)) !== null && _statusOf !== void 0 ? _statusOf : 500, context);
};